<div class="top-list">
  <!-- Header -->
  <div class="top-list__header">
    <h3 class="top-list__title">
      <i class="pi" [ngClass]="icon"></i>
      {{ title }}
    </h3>
    @if (hasMoreItems) {
      <button class="top-list__see-all" (click)="onSeeAll()">
        {{ "STATISTICS.TOP_LIST.SEE_ALL" | translate }}
        <i class="pi pi-arrow-right"></i>
      </button>
    }
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div class="top-list__items">
      @for (i of loadingItems; track i) {
        <div class="top-list__item top-list__item--loading">
          <div class="top-list__rank-skeleton"></div>
          <div class="top-list__info-skeleton">
            <div class="top-list__name-skeleton"></div>
            <div class="top-list__count-skeleton"></div>
          </div>
          <div class="top-list__value-skeleton"></div>
        </div>
      }
    </div>
  }

  <!-- Empty State -->
  @else if (items.length === 0) {
    <div class="top-list__empty">
      <i class="pi pi-inbox"></i>
      <span>{{ emptyMessage | translate }}</span>
    </div>
  }

  <!-- Items -->
  @else {
    <div class="top-list__items">
      @for (item of displayItems; track item.id; let i = $index) {
        <div class="top-list__item" (click)="onItemClick(item)">
          <!-- Rank -->
          @if (showRank) {
            <span class="top-list__rank" [class.top-list__rank--top3]="i < 3">
              {{ i + 1 }}
            </span>
          }

          <!-- Info -->
          <div class="top-list__info">
            @if (item.routerLink) {
              <a
                class="top-list__name top-list__name--link"
                [routerLink]="item.routerLink"
                (click)="$event.stopPropagation()"
              >
                {{ item.name }}
              </a>
            } @else {
              <span class="top-list__name">{{ item.name }}</span>
            }
            @if (showCount) {
              <span class="top-list__count">
                @if (
                  item.secondaryCount !== undefined && item.secondaryCount !== null
                ) {
                  {{
                    "STATISTICS.TOP_LIST.COUNT_WITH_APPOINTMENTS"
                      | translate
                        : { count: item.count, appointments: item.secondaryCount }
                  }}
                } @else {
                  {{
                    "STATISTICS.TOP_LIST.COUNT_ONLY"
                      | translate: { count: item.count }
                  }}
                }
              </span>
            }
          </div>

          <!-- Value & Trend -->
          <div class="top-list__value-container">
            <span class="top-list__value">{{ formatValue(item.value) }}</span>
            @if (showTrend && item.trend !== undefined) {
              <span
                class="top-list__trend"
                [ngClass]="'top-list__trend--' + getTrendClass(item.trend)"
              >
                <i class="pi" [ngClass]="getTrendIcon(item.trend)"></i>
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
